import React from 'react';
import styles from './MultiSelect.module.scss';
import Select from 'react-select';
import _ from 'lodash';
import { FiInfo } from "react-icons/fi";
import Tooltip from "../Tooltip/Tooltip";

class MultiSelect extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: this.props.selected ? this.props.selected : null,
            placeholder: this.props.placeholder ? this.props.placeholder : null,
        }
    }

    valueSelectedHandler(data) {
        let selection = { ...data };

        _.forEach(this.props.options ? this.props.options : [], (v, k) => {
            if (v.value === selection.value) {
                selection.key = k;
            }
        })

        this.setState({ value: selection }, () => {
            this.props.onValueChange(this.state.value);
        })
    }

    render() {
        let options = this.props.options ? this.props.options : [];

        const customStyles = {
            control: (base, state) => ({
                ...base,
                background: "#f7f6f9",
                borderRadius: '5px',
                borderColor: "#dededf",
                boxShadow: '0 0.125rem 0.25rem #00000014',
                height: '40px'
            }),
            menu: base => ({
                ...base,
                borderRadius: 0,
                marginTop: '1px',
                zIndex: 9999
            }),
            menuList: base => ({
                ...base,
                padding: 0,
                zIndex: 9999
            }),
            menuPortal: base => ({
                ...base,
                zIndex: 9999
            }),
        };

        return (
            <div className={ `${styles[ 'container' ]}` }>
                <Select
                    value={ this.props.selected }
                    placeholder={ this.state.placeholder }
                    closeMenuOnSelect={ !this.props.multi }
                    className={ `${styles[ 'select' ]}` }
                    isMulti={ !!this.props.multi }
                    options={ options }
                    styles={ customStyles }
                    menuPosition={ 'fixed' }
                    isSearchable={ this.props.searchable ? this.props.searchable : false }
                    onChange={ (data) => this.valueSelectedHandler(data) }
                    isDisabled={ this.props.disabled }
                    isClearable={ this.props.clearable }
                />
                { this.props.tooltip ?
                    <span className={ styles.tooltip }>
                        <Tooltip content={ this.props.tooltip }>
                            <FiInfo className={ styles.infoIcon } />
                        </Tooltip>
                    </span>
                    :
                    null
                }
            </div>

        );
    }
}

export default MultiSelect;
